import { ReactNode } from "react";

export default function Failed(): ReactNode {
  return (
    <div className="flex flex-col gap-5 place-items-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="86"
        fill="#F25066"
        className="bi bi-exclamation-circle"
        viewBox="0 0 16 16"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
      </svg>
      <h4 className="mt-4 mb-3 font-bold" style={{ color: "#F25066" }}>
        Payment Failed.
      </h4>

      <p className="text-zinc-400">
        We recommend trying any of the following solutions below.
      </p>

      <ul className="list-disc text-zinc-400 text-muted">
        <li>Use an alternate card.</li>
        <li>Contact your bank.</li>
        <li>Wait a few hours and try again.</li>
        <li>Make sure your card has enough funds to cover this transaction.</li>
      </ul>
    </div>
  );
}
